import { Descriptions, Table, TableColumnsType } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getClassStudentPoints } from "../../../api/campusClasses.api";
import useAxios from "../../../hooks/useAxios";
import { IClassStudentPoint, IGetClassStudentPoints } from "../../../models/campusClasses.model";
import { RootState } from "../../../store/rootReducer";
import Button from "../../Button";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import PointDetailModal from "./modals/PointDetailModal";

const ClassPoint = () => {
  const { t } = useTranslation();
  const { chosenClass } = useSelector((state: RootState) => state.class);
  const { data: res, isLoading, error, execute } = useAxios<IGetClassStudentPoints>();

  const [pointDetailVisible, setPointDetailVisible] = useState(false);
  const [memberCode, setMemberCode] = useState('');

  useEffect(() => {
    if (chosenClass) {
      execute(getClassStudentPoints(chosenClass.classCode));
    }
  }, [chosenClass]);

  const columns: TableColumnsType<IClassStudentPoint> = [
    {
      title: t('class.class.column82'),
      dataIndex: 'memberKorName',
      key: 'memberKorName',
      align: 'center',
    },
    {
      title: t('class.class.column83'),
      dataIndex: 'memberEngName',
      key: 'memberEngName',
      align: 'center',
    },
    {
      title: t('class.class.column84'),
      dataIndex: 'point',
      key: 'point',
      align: 'center',
    },
    {
      title: t('class.class.column85'),
      key: 'memberCode',
      dataIndex: 'memberCode',
      align: 'center',
      render: value => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            onClick={() => {
              setMemberCode(value);
              setPointDetailVisible(true);
            }}
            className="btn-basic small mint"
            text={t('class.class.column85')}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <div className='comm-table__area rowType edit'>
        <Descriptions
          bordered
          column={3}
          size="small"
          labelStyle={{ width: '16.6%' }}
          contentStyle={{ width: '16.6%' }}
        >
          <Descriptions.Item label={t('class.class.column86')}>
            {chosenClass?.courseSubName}
          </Descriptions.Item>
          <Descriptions.Item label={t('class.class.column87')}>
            {chosenClass?.courseDetailName}
          </Descriptions.Item>
          <Descriptions.Item label={t('class.class.column88')}>
            {chosenClass?.className}
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className='comm-table__area'>
        <Table
          columns={columns}
          dataSource={res?.data}
          pagination={{
            current: 1,
            pageSize: 9999999,
          }}
        />
      </div>

      {pointDetailVisible &&
        <PointDetailModal
          visible={pointDetailVisible}
          setVisible={setPointDetailVisible}
          classCode={chosenClass?.classCode}
          memberCode={memberCode}
        />
      }
    </>
  );
}

export default ClassPoint;
